<template>
  <div class="recruit-wrapper">
    <h2 :style="makeColor()">求人を検索する</h2>
    <div class="-recruit-card" style="padding: 8px;">
      <div class="-left-search">
        <b>地域</b>
      </div>
      <div class="-right-search">
        <select class="select" v-model="placeInput">
          <option v-for="(p, pIdx) in place" :key="pIdx + '-place'">
            {{p}}
          </option>
        </select>
      </div>
      <div class="-left-search">
        <b>職種</b>
      </div>
      <div class="-right-search">
        <select class="select" v-model="workInput">
          <option v-for="(w, wIdx) in workType" :key="wIdx + '-work'">
            {{w}}
          </option>
        </select>
      </div>
      <div class="-left-search">
        <b>詳細ワード</b>
      </div>
      <div class="-right-search">
        <input class="input is-small" placeholder="検索する" v-model="searchInput"/>
      </div>
    </div>
    <h2 :style="makeColor()">
      <template v-if="!searchInput && !workInput && !placeInput">おすすめ求人</template>
      <template v-else>検索結果</template>
    </h2>
    <template v-for="(page, idx) in widgetData.recruit">
      <transition name="search-res" :key="idx">
        <div
          class="-recruit-card"
          @click="openRecruit(page)"
          v-if="searchFilter(page,idx)">
          <div class="-recruit-left">
            <img :src="getImageURL(page)"/>
          </div>
          <div class="-recruit-right">
            <p>{{page.content.title}}</p>
            <b-tag type="is-info" style="margin: 2px; width: 120px;">
              {{page.content.work_title}}
            </b-tag>
          </div>
          <a :style="makeColor()" style="position: absolute; right: 8px; top: 22px; font-size: 24px;">
            <span class="mdi mdi-chevron-right"></span>
          </a>
        </div>
      </transition>
    </template>
    <transition name="no-recruit">
      <div v-if="showRecruitNum==0">該当する求人はありません</div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: Object,
      required: true
    },
    widgetData: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      searchInput: null,
      workInput: null,
      placeInput: null,
    }
  },
  computed: {
    workType () {
      let temp = ['']
      for (const r of this.widgetData.recruit) {
        temp.push(r.content.work_title)
      }
      return this.$_.union(temp)
    },
    place () {
      let temp = ['']
      for (const r of this.widgetData.recruit) {
        if (r.content.address) {
          if (r.content.address.region) {
            temp.push(r.content.address.region)
          }
        }
      }
      return this.$_.union(temp)
    },
    showRecruitNum () {
      return this.widgetData.recruit.filter(this.searchFilter).length
    }
  },
  methods: {
    changeView (isDetail, isStoryView, viewType) {
      this.$emit('changeView', {
        isDetail: isDetail,
        isStoryView: isStoryView,
        viewType: viewType
      })
    },
    getImageURL (c) {
      var url = ''
      if (c.is_image_original) {
        url = c.image
      } else {
        if (c.image_unsplash) {
          url = c.image_unsplash.urls['thumb'] ? c.image_unsplash.urls.thumb : c.image_unsplash.urls.raw
        } else {
          url = c.image_url
        }
      }
      const defaultURL = require('@/assets/template/default_recruit.jpg')
      if (url == '') return defaultURL
      else return url
    },
    makeColor () {
      return {
        'color': this.color.iconBg + '!important'
      }
    },
    openRecruit (page) {
      const url = process.env.LOC_HOST + '/recruit/detail/' + page.company_id + '/' + page.contents_id
      this.$emit('openRecruit', url)
      this.changeView(false, true, null)
    },
    searchFilter (page, idx) {
      // 検索何も入力無し
      if (!this.searchInput && !this.workInput && !this.placeInput) {
        return idx < 5
      } else {
        let strJson = JSON.stringify(page.content)
        let searchS = !this.searchInput ? '' : this.searchInput
        let searchW = !this.workInput   ? '' : this.workInput
        let searchP = !this.placeInput  ? '' : this.placeInput
        if (
          this.compareStr(strJson, searchS)
          &&
          this.compareStr(strJson, searchW)
          &&
          this.compareStr(strJson, searchP)
        ) return true
      }
      return false
    },
    compareStr (a, b) {
      if (b) return ~a.toLowerCase().indexOf(b.toLowerCase())
      else return true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.recruit-wrapper {
  border-radius: 8px;
  width: calc(100% - 24px);
  height: auto;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  margin: 8px;
  padding: 8px 0px;
  h2 {
    width: 100%;
    padding: 8px 16px;
    text-align: left;
    font-weight: 600;
    font-size: 16px;
  }
  .-recruit-card {
    position: relative;
    border-radius: 8px;
    height: auto;
    width: calc(100% - 24px);
    margin: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    cursor: pointer;
    .-left-search {
      padding: 4px 8px;
      width: 96px;
      text-align: left;
    }
    .-right-search {
      padding: 4px 8px;
      width: calc(100% - 120px);
      text-align: left;
    }
    .-recruit-left {
      width: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: auto;
        max-height: 100px;
        width:  120px;
        border-radius: 16px;
        padding: 12px;
        object-fit: cover;
      }
    }
    .-recruit-right {
      width: calc(100% - 120px);
      padding: 8px;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: -16px;
      p {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-left: 8px;
        text-align: left;
        font-size: 13px;
        font-weight: 600;
      }
      button {
        padding: 8px 16px;
        border-radius: 16px;
      }
    }
  }
  .-recruit-card:hover {
    transform: scale(1.025);
  }
}
.search-res-enter, .search-res-leave-to, .no-recruit-enter {
  opacity: 0;
}
.search-res-enter-to, .search-res-leave, .no-recruit-enter-to {
  opacity: 1;
}
.search-res-enter-active, .no-recruit-enter-active {
  transition: all 0.4s;
}
.search-res-leave-active {
  transition: all 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/RecruitContent.vue